import { Children, isValidElement, cloneElement } from "react";
function sharePropsWithChildren({
  children,
  sharedProps
}) {
  return Children.map(children, (child) => {
    if (!isValidElement(child)) return null;
    return cloneElement(child, {
      ...child.props,
      ...sharedProps ?? {}
    });
  });
}
export {
  sharePropsWithChildren
};
